import { Lock } from "lucide-react";
import { Card, CardContent } from "./ui/card";

const PrivacyNotice = ({ className = "" }) => {
  return (
    <Card className={`bg-muted/30 border-border ${className}`}>
      <CardContent className="p-4">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
            <Lock className="w-5 h-5 text-primary" />
          </div>
          <div>
            <h3 className="font-semibold text-foreground mb-2" style={{ fontFamily: 'Manrope' }}>
              Your Privacy
            </h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>VALORLink collects only information needed to provide peer support and platform safety.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>We do not sell user data.</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>Information may be reviewed if there is a safety concern or incident.</span>
              </li>
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default PrivacyNotice;
